/** Display and parsing helpers for the budget and capacity screens. */

export const hoursLabel = (minutes: number): string => `${(Math.round((minutes / 60) * 10) / 10).toLocaleString()} h`;

export function moneyLabel(cents: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

/** "12.5" hours to minutes; empty is null (no budget); anything else invalid is undefined. */
export function parseHours(text: string): number | null | undefined {
  const t = text.trim();
  if (t === "") return null;
  if (!/^\d+(\.\d+)?$/.test(t)) return undefined;
  return Math.round(Number(t) * 60);
}

/** "1500.50" to cents; empty is null; invalid is undefined. */
export function parseMoney(text: string): number | null | undefined {
  const t = text.trim().replace(/,/g, "");
  if (t === "") return null;
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return undefined;
  return Math.round(Number(t) * 100);
}

export const editHours = (minutes: number | null): string => (minutes === null ? "" : String(Math.round((minutes / 60) * 100) / 100));
export const editMoney = (cents: number | null): string => (cents === null ? "" : (cents / 100).toFixed(2));
